<div class="broker-credits-purchases">
  <div *ngIf="!hideCredits">
    <ul class="list__heading margin-bottom-half">
      <li>
        {{
          (distributor.subscriptions.credits ? 'distributors.creditsBalance' : 'distributors.balanceSeats') | translate
        }}: <b>{{ distributor.brokerBalance.amount }}</b>
      </li>
      <li *ngIf="distributor.type === 'distributor'">
        {{ 'nouns.expirationDate' | translate }}: <b>{{ distributor.brokerBalance.expirationDate | date }}</b>
      </li>
    </ul>
  </div>

  <lms-list
    [listId]="listId"
    [serviceProvider]="dataService"
    (collectionUpdated)="setCollection($event)"
    [options]="{ filters: filters, sort: '-created_at' }"
  >
    <div class="table-heading">
      <lms-list-header
        [listId]="listId"
        class="table-item"
        field="amount"
        [label]="distributor.subscriptions.credits ? 'credits.order.credits' : 'credits.order.seatsAmount'"
      >
      </lms-list-header>
      <lms-list-header [listId]="listId" class="table-item" field="expirationDate" label="nouns.expirationDate">
      </lms-list-header>
      <lms-list-header
        [listId]="listId"
        class="table-item hide-on-med-and-down"
        field="reference"
        label="nouns.reference"
      ></lms-list-header>
      <lms-list-header
        [listId]="listId"
        class="table-item hide-on-med-and-down"
        field="comments"
        label="nouns.comments"
      ></lms-list-header>
      <lms-list-header
        [listId]="listId"
        class="table-item hide-on-med-and-down"
        field="created_at"
        label="nouns.createdDate"
      ></lms-list-header>
    </div>

    <div class="table-row" *ngFor="let purchase of purchases">
      <div class="table-item">{{ purchase.amount || '-' }}</div>
      <div class="table-item">{{ purchase.expirationDate | date }}</div>
      <div class="table-item hide-on-med-and-down">{{ purchase.reference }}</div>
      <div class="table-item hide-on-med-and-down">{{ purchase.comments }}</div>
      <div class="table-item hide-on-med-and-down">{{ purchase.created_at | date }}</div>
    </div>
  </lms-list>
</div>
